const observer = lozad(); // lazy loads elements with default selector as '.lozad'
observer.observe();

window.addEventListener('DOMContentLoaded', (e) => {
    const list_block = document.querySelectorAll('.list_block');
   list_block.forEach((item) => {
      const text = item.innerHTML;
     if (!text.includes(':')) {
        return;
      }
      const splitText = text.split(':');
      const boldText = `<b>${splitText[0]}</b>`;
      const newText = `${boldText}:${splitText[1]}`;
      item.innerHTML = newText;
    });
  
  const listItems = document.querySelectorAll('.multicolumn-list__item');
  for (let i = 0; i < listItems.length; i++) {
    const link = listItems[i].querySelector('a');
    listItems[i].setAttribute('href', link.href);
    listItems[i].addEventListener('click', function() {
      window.location.href = this.getAttribute('href');
    });
  }
})